/**
 * Tutorial guidato delle impostazioni Corrieri.
 *
 * Un preparativo solo: il riquadro del primo corriere, che il passo dedicato apre
 * per mostrarne i campi. `stopCouriersTour` lo richiude a fine giro, e solo se ad
 * aprirlo e' stato il tutorial. Gli interruttori non si toccano: salvano subito.
 */
const SCOPE = '[data-tour-scope="setting-couriers"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro del primo corriere, se non e' gia' aperto. */
function openFirst() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopCouriersTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createCouriersTourSteps() {
	return [
		{
			body: "Qui si collegano i corrieri veri - quelli che ritirano i pacchi - al gestionale: da collegati, le spedizioni si creano da dentro, le etichette si stampano e i tracking tornano indietro da soli. E' cosa diversa dai Metodi di spedizione, che sono le voci che il cliente vede alla cassa.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I corrieri',
		},
		{
			body: "Una riga per corriere, con il suo interruttore. Acceso vuol dire che il gestionale prova a usarlo per creare spedizioni: se le credenziali non sono a posto, la spedizione fallisce al momento di crearla. L'interruttore salva subito.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Accendere un corriere',
		},
		{
			body: "Il piu' a inizio riga apre la configurazione. Oltre alle credenziali, qui c'e' spesso l'indirizzo del webhook da incollare nel pannello del corriere: e' il canale da cui arrivano gli aggiornamenti di stato: senza quello le spedizioni partono ma il tracking non si aggiorna mai.",
			before: stopCouriersTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire la configurazione',
		},
		{
			body: 'Chiavi, endpoint e segreto del webhook si compilano con quello che il corriere ha rilasciato e si confermano con Conferma, qui dentro. Ogni riquadro salva il proprio corriere.',
			before: openFirst,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'Credenziali e webhook',
		},
	];
}
